import React from "react";
import './krishnapage.css';

function KrishnaInnerTemplePage() {
    return (  
        <div>           
            <section id="krishnapage">
                <div className="cs-container">
                    <div className="cs-content">
                        <h1 className="cs-title">About Krishna Temple</h1>
                        <p>Radha Krishna Temple will be a place where you can enjoy the love for God, celebrate festivals with the community, practice meditation, enrich your children with rich Vedic culture, or simply relax and enjoy the spiritual environment with your family. </p>
                        <p>Help manifest this beautiful dwelling of Radha Krishna! Receive the blessings of God by participating in this noble mission!.</p>
                        
                        <img src="/images/article-details-large.jpg" width="369" height="290" alt="Krishna"></img>
                        <h2>Dieties At the Temple</h2>
                        <ul>
                            <li><strong>To your left</strong> is - Lord Ram, Lord Lakshman, Goddess Sita, and Lord Hanuman</li>
                            <img src="/images/customer-logo-2.png" alt="Krishna"></img>
                            <li><strong>In the middle </strong> is - Krishna and Radha</li>
                            <img src="/images/customer-logo-1.png" alt="Krishna"></img>
                            <li><strong>To right side </strong> is, Lord Jagannatha, Lord Baladeva and Goddess Subhadra</li>
                            <img src="/images/customer-logo-4.png" alt="Krishna"></img>
                            <li><strong>On the lower level </strong> of the Alter, we see the different Linages</li>
                            <img src="/images/customer-logo-6.png" alt="Krishna"></img>
                        </ul>
                        <p>
                        Please visit the Temple daily at the following times for Arati Darshan of their Lordships Sri Sri Radha Govinda Deva. We have special programs every Sunday starting at 6:30 pm with Arati of their lordships, Spiritual discourses, Bhajans, and a free prasadam feast.
                        </p>
                        <h2>Krishna Temple Timings</h2>
                        <table className="cs-table">
                            <thead>
                                <tr className="cs-color">
                                    <th className="cs-th">Temple Timing</th>
                                    <th className="cs-th">WeekDay</th>
                                    <th className="cs-th">Sunday</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="cs-tr">
                                    <td className="cs-td">Morning Darshan Timing</td>
                                    <td className="cs-td">8:00 am to Noon </td>
                                    <td className="cs-td">9:00 am to Noon </td>
                                </tr>
                                <tr className="cs-tr">
                                    <td className="cs-td">Evening Darshan Timing</td>
                                    <td className="cs-td">5:00 to 9:00 pm </td>
                                    <td className="cs-td">5:00 to 9:00 pm </td>
                                </tr>
                            </tbody>
                        </table>
                        <h2>Krishna Temple Daily Events</h2>
                        <table className="cs-table">
                            <thead>
                                <tr className="cs-color">
                                    <th className="cs-th">Daily Events</th>
                                    <th className="cs-th">WeekDay</th>
                                    <th className="cs-th">Sunday</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="cs-tr">
                                    <td className="cs-td">Morning Program</td>
                                    <td className="cs-td">4:30 am: Mangala Arati <br />&nbsp;<br />
                                                        5:00 am: Tulasi Puja <br />&nbsp;<br />
                                                        5:15 am: Japa (mantra meditation) <br />&nbsp;<br />
                                                        7:00 am: Guru Puja <br />&nbsp;<br />
                                                        7:15 am: Sringar Arati – Greeting of The Deities <br />&nbsp;<br />
                                                        7:45 am: Srimad Bhagavatam Class <br />&nbsp;<br />
                                                        12:30 pm: Raj Bhoga Arati <br />&nbsp;<br />
                                    </td>
                                    <td className="cs-td">4:30 am: Mangala Arati <br />&nbsp;<br />
                                                        5:00 am: Tulasi Puja <br />&nbsp;<br />
                                                        5:15 am: Japa (mantra meditation) <br />&nbsp;<br />
                                                        7:00 am: Guru Puja <br />&nbsp;<br />
                                                        7:15 am: Sringar Arati – Greeting of The Deities <br />&nbsp;<br />
                                                        7:45 am: Srimad Bhagavatam Class <br />&nbsp;<br />
                                                        12:30 pm: Raj Bhoga Arati <br />&nbsp;<br />
                                    </td>
                                </tr>
                                <tr className="cs-tr">
                                    <td className="cs-td">Evening Program</td>
                                    <td className="cs-td">6:30 pm: Gaura Arati (Sandhya Arati) <br />&nbsp;<br />
                                        8:15 pm: Shayan Arati <br />&nbsp;<br />
                                        8:30 pm: Temple Closes</td>

                                    <td className="cs-td">6:30 pm: Gaura Arati (Sandhya Arati) <br />&nbsp;<br />
                                        8:15 pm: Shayan Arati <br />&nbsp;<br />
                                        8:30 pm: Temple Closes</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="cs-image-group">
                        <picture className="cs-picture">
                            <source media="(max-width: 600px)" srcSet="/images/temple-landscape.jpg"></source>
                            <source media="(min-width: 601px)" srcSet="/images/temple-landscape.jpg"></source>
                            <img loading="lazy" decoding="async" src="/images/temple-landscape.jpg" alt="Kirishna temple" width="570" height="680"></img>
                        </picture>
                    </div>
                </div>
                <picture className="cs-background">
                    <img src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Images%2FGraphics%2Flarge-waves.svg" alt="waves" decoding="async" aria-hidden="true" width="625" height="952"></img>
                </picture>
            </section>  
        </div>                                
    );
}
export default KrishnaInnerTemplePage;